import React, {useMemo} from "react";
import PropTypes from "prop-types";
import { Table, Form, Select, Input, Switch } from "antd";
import { MinusCircleOutlined } from "@ant-design/icons";
import { Controller } from "react-hook-form";
import CustomInput from "../../Common/MobileInputMask";
import { APP_LIST } from "../../../views/Users/utils/utils";
import SolutionAccessDropDown from "../../Users/SSOIntegration/SolutionAccessDropDown";

const { Option } = Select;

const getRolesForMainRole = (mainRole, mappedRoleSet) => {
    let matchingRoles = [];
    matchingRoles = mappedRoleSet?.filter(
      (e) =>
        e?.main_role_id?.main_role_name?.toLowerCase() ===
        mainRole?.toLowerCase(),
    );
    return matchingRoles;
  };

const BulkUserCreationTable = (props) => {
  const {
    dataSource,
    errors,
    control,
    hotelList,
    mainRoles,
    mappedRoles,
    watch,
    statusArray,
    start,
    remove,
    applications = [],
    applicationRoles = [],
  } = props;

  const APP_NAMES = APP_LIST.map((item) => item.app_name);

  const getAppRolesOptions = (app_id) => {
    let getAppList = applications.filter(app=>APP_NAMES.includes(app.app_name)).find((item) => item._id === app_id);
    let processedOptionList = applicationRoles.filter(
      (text) => text.app_id === getAppList._id,
    );

    return processedOptionList.map((item) => {
      return {
        _id: item._id,
        role_name: item.role_name,
      };
    });
  };

  const hotelCodeOptions = useMemo(
    () =>
      hotelList.map((hotel) => (
        <Option key={hotel.hotel_id} value={hotel.hotel_code}>
          {hotel.hotel_code}
        </Option>
      )),
    [hotelList],
  );

  const mainRolesOptions = useMemo(
    () =>
      mainRoles.map((d) => (
        <Option key={d?._id} value={d?.main_role_name}>
          {d?.main_role_name}
        </Option>
      )),
    [mainRoles],
  );

  const getRoleOptions = (mainRole) => {
    const matchingRoles = getRolesForMainRole(mainRole, mappedRoles);
    let roleOptions = [];

    if (matchingRoles?.length > 0) {
      roleOptions = matchingRoles?.map((d) => (
        <Option key={d?._id} value={d?.role_name}>
          {d?.role_name}
        </Option>
      ));
    }

    return roleOptions;
  };

  const columns = [
    {
      title: "Hotel Code",
      dataIndex: "hotel_code",
      key: "hotel_code",
      width: "200px",
      fixed: "left",
      render: (_text, _record, index) => (
        <Form.Item
          validateStatus={errors?.formData?.[index]?.hotel_code ? "error" : ""}
        >
          <Controller
            render={({ field }) => (
              <Select
                {...field}
                showSearch
                optionFilterProp="children"
                notFoundContent={null}
              >
                {hotelCodeOptions}
              </Select>
            )}
            name={`formData.${index}.hotel_code`}
            control={control}
          />
        </Form.Item>
      ),
    },
    {
      title: "First Name",
      dataIndex: "first_name",
      key: "first_name",
      width: "200px",
      render: (_text, _record, index) => (
        <Form.Item
          validateStatus={errors?.formData?.[index]?.first_name ? "error" : ""}
        >
          <Controller
            render={({ field }) => <Input {...field} />}
            name={`formData.${index}.first_name`}
            control={control}
          />
        </Form.Item>
      ),
    },
    {
      title: "Last Name",
      dataIndex: "last_name",
      key: "last_name",
      width: "200px",
      render: (_text, _record, index) => (
        <Form.Item
          validateStatus={errors?.formData?.[index]?.last_name ? "error" : ""}
        >
          <Controller
            render={({ field }) => <Input {...field} />}
            name={`formData.${index}.last_name`}
            control={control}
          />
        </Form.Item>
      ),
    },
    {
      title: "User Name",
      dataIndex: "user_name",
      key: "user_name",
      width: "250px",
      render: (_text, _record, index) => (
        <Form.Item
          validateStatus={errors?.formData?.[index]?.user_name ? "error" : ""}
        >
          <Controller
            render={({ field }) => <Input {...field} />}
            name={`formData.${index}.user_name`}
            control={control}
          />
        </Form.Item>
      ),
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      width: "250px",
      render: (_text, _record, index) => (
        <Form.Item
          validateStatus={errors?.formData?.[index]?.email ? "error" : ""}
        >
          <Controller
            render={({ field }) => <Input {...field} />}
            name={`formData.${index}.email`}
            control={control}
          />
        </Form.Item>
      ),
    },
    {
      title: "Two Factor Authentication",
      dataIndex: "two_factor_authentication",
      key: "two_factor_authentication",
      width: "200px",
      render: (_text, _record, index) => {
        return (
          <Form.Item valuePropName={"checked"}>
            <Controller
              render={({ field: { onChange, onBlur, value, name, ref } }) => (
                <Switch
                  onBlur={onBlur} // notify when input is touched
                  onChange={onChange} // send value to hook form
                  checked={value}
                  // inputref={ref}
                />
              )}
              name={`formData.${index}.two_factor_authentication`}
              control={control}
            />
          </Form.Item>
        );
      },
    },
    {
      title: "Mobile",
      dataIndex: "mobile",
      key: "mobile",
      width: "200px",
      render: (_text, _record, index) => (
        <Form.Item
          validateStatus={errors?.formData?.[index]?.mobile ? "error" : ""}
        >
          <Controller
            render={({ field }) => (
              <CustomInput
                {...field}
                // value={this.state.value}
                // onChange={(e) => this.setState({ value: e.target.value })}
                mask="999-999-9999"
              />
            )}
            name={`formData.${index}.mobile`}
            control={control}
          />
        </Form.Item>
      ),
    },
    {
      title: "Main Role",
      dataIndex: "main_role",
      key: "main_role",
      width: "320px",
      render: (_text, _record, index) => (
        <Form.Item
          validateStatus={errors?.formData?.[index]?.main_role ? "error" : ""}
        >
          <Controller
            render={({ field }) => (
              <Select
                {...field}
                showSearch
                optionFilterProp="children"
                notFoundContent={null}
              >
                {mainRolesOptions}
              </Select>
            )}
            name={`formData.${index}.main_role`}
            control={control}
          />
        </Form.Item>
      ),
    },
    {
      title: "Role",
      dataIndex: "role",
      key: "role",
      width: "320px",
      render: (_text, _record, index) => (
        <Form.Item
          validateStatus={errors?.formData?.[index]?.role ? "error" : ""}
        >
          <Controller
            render={({ field }) => (
              <Select
                {...field}
                showSearch
                optionFilterProp="children"
                notFoundContent={null}
              >
                {getRoleOptions(watch(`formData.${index}.main_role`))}
              </Select>
            )}
            name={`formData.${index}.role`}
            control={control}
          />
        </Form.Item>
      ),
    },
    ...(process.env.REACT_APP_PLATFORM_TYPE !== "MARRIOTT"
      ? [
          {
            title: "Account Activation",
            dataIndex: "account_activation",
            key: "account_activation",
            width: "200px",
            render: (_text, _record, index) => {
              return (
                <Form.Item
                // name={[record._id, "account_activation"]}
                // valuePropName={text === true && "checked"}
                >
                  <Controller
                    render={({
                      field: { onChange, onBlur, value, name, ref },
                    }) => (
                      <Switch
                        onBlur={onBlur} // notify when input is touched
                        onChange={onChange} // send value to hook form
                        checked={value}
                        // inputref={ref}
                      />
                    )}
                    name={`formData.${index}.account_activation`}
                    control={control}
                  />
                </Form.Item>
              );
            },
          },
        ]
      : []),
    ...(applications
      ? applications
          .filter((app) => APP_NAMES.includes(app.app_name))
          .map((app) => ({
            title: app.app_name,
            dataIndex: app._id,
            key: app._id,
            width: "150px",
            align: "center",
            render: (_text, _record, index) => (
              <Form.Item
              // validateStatus={
              //   // errors?.formData?.[index]?.role ? "error" : ""
              // }
              >
                <Controller
                  render={({ field: { value, onChange, onBlur } }) => (
                    <SolutionAccessDropDown
                      value={value}
                      onChange={onChange}
                      onBlur={onBlur}
                      options={getAppRolesOptions(app._id)}
                      app_name={app.app_name}
                    />
                  )}
                  name={`formData.${index}.${app._id}`}
                  control={control}
                />
              </Form.Item>
            ),
          }))
      : []),
    {
      title: "Remove",
      dataIndex: "operation",
      width: "80px",
      fixed: "right",
      align: "center",
      render: (_text, _record, index) => (
        <MinusCircleOutlined
          className="dynamic-delete-button"
          style={{ margin: "0 8px" }}
          onClick={() => remove(index)}
        />
      ),
    },
    ...(start
      ? [
          {
            title: "Status",
            dataIndex: "status",
            key: "status",
            width: "150px",
            fixed: "right",
            align: "center",
            render: (_text, _record, index) => statusArray[index],
          },
        ]
      : []),
  ];

  return (
    <Table
      columns={columns}
      dataSource={dataSource}
      size="small"
      rowKey="id"
      pagination={false}
      scroll={{ x: 3950 }}
    />
  );
};

BulkUserCreationTable.propTypes = {};

export default BulkUserCreationTable;
